import { Component, EventEmitter, Injector, Output, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { FindProductOutputDto, FindCustomerOutputDto } from '@shared/service-proxies/service-proxies';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import {
    CommonLookupServiceProxy
} from '@shared/service-proxies/service-proxies';
@Component({
  selector: 'app-search-customer',
  standalone: false,
  
    templateUrl: './search-customer.component.html',
    styleUrl: './search-customer.component.css',
  
})
export class SearchCustomerComponent {
    @Input() customerSelectedItem: FindCustomerOutputDto;
    @Output() customerEvent = new EventEmitter<FindCustomerOutputDto>();
    customers: FindCustomerOutputDto[];
    /*productSelectedItem: FindProductOutputDto;*/
    filterText = '';

    constructor(
        private _commonLookupServiceProxy: CommonLookupServiceProxy
    ) {

    }


    filterCustomer(event: AutoCompleteCompleteEvent) {
        this.filterText = event.query.toLowerCase();
        this.getcustomers();
    }

    oncustomerselected(event: any) {
        this.customerEvent.emit(event.value);
    }


    getcustomers() {
        this._commonLookupServiceProxy
            .getAllCustomerForLookupTable(this.filterText, undefined, undefined, 100000)
            .subscribe((result) => {
                this.customers = result.items;
            });
    }
}
